import { FC, memo, useCallback, useState } from 'react'
import { Modal } from 'components/layouts/modal/modal'
import { ChatStartUserTabPanel } from './components/chatStartUserTabPanel/chatStartUserTabPanel'
import {
  ChatStartTab,
  ChatStartTabs,
} from './components/chatStartTab/chatStartTab'
import { ChatStartGroupTabPanel } from './components/chatStartGroupTabPanel/chatStartGroupTabPanel'
import {
  setGroupTabSearchKeyword,
  setUserTabSearchKeyword,
} from './states/chatStartEntryDialogSlice'
import { useAppDispatch } from 'states/hooks'

type ChatStartEntryDialogProps = {
  title: string
  isOpen: boolean
  onClose: () => void
}

// チャット開始ダイアログ
export const ChatStartEntryDialog: FC<ChatStartEntryDialogProps> = memo(
  (props) => {
    const dispatch = useAppDispatch()

    // ダイアログを閉じる際に呼ばれるハンドラ
    const handleClose = useCallback(() => {
      // 各タブの検索条件を初期化
      dispatch(setUserTabSearchKeyword(''))
      dispatch(setGroupTabSearchKeyword(''))

      // 呼出元へ閉じるイベントを通知
      props.onClose()
    }, [dispatch, props])

    // タブの選択状態
    const [selectedId, setSelectedId] = useState<string>(ChatStartTabs.User.id)

    // タブパネルの表示
    const renderTabPanel = useCallback(() => {
      switch (selectedId) {
        // ユーザータブ
        case ChatStartTabs.User.id:
          return <ChatStartUserTabPanel onClose={handleClose} />
        // グループタブ
        case ChatStartTabs.Group.id:
          return <ChatStartGroupTabPanel onClose={handleClose} />
        default:
          return null
      }
    }, [handleClose, selectedId])

    return (
      <Modal
        title={props.title}
        isOpen={props.isOpen}
        onClose={handleClose}
        className="!h-[90vh] max-w-[450px] "
      >
        {/* タブ選択 */}
        <ChatStartTab
          selectedId={selectedId}
          onTabsSelectionChanged={setSelectedId}
        />

        {/* タブ選択状態に応じて各パネルを表示 */}
        <div className="py-3 flex-1 min-h-0">{renderTabPanel()}</div>
      </Modal>
    )
  }
)
